import useMeQuery from '@/api/queries/me/useMeQuery';
import { computed, inject } from 'vue';
import type { GetAppsUrls } from '@/plugins/env-urls/types';

export function useSpaces() {
  const { permissions, me } = useMeQuery();
  const appUrl = inject('appUrl') as GetAppsUrls;

  const isRecruiter = computed(() => permissions.value && permissions.value.includes('rct_r'));
  const isAdmin = computed(() => permissions.value && permissions.value.includes('cadm_r'));
  const isManager = computed(() => {
    const isManager = permissions.value && permissions.value.includes('mng_r');
    return !isRecruiter.value && isManager;
  });

  const managerOneCompany = computed(
    () => isManager.value && !isAdmin.value && me.value?.managers?.length === 1,
  );
  const adminOnly = computed(() => isAdmin.value && !isManager.value && !isRecruiter.value);
  const recruiterOnly = computed(
    () =>
      permissions.value &&
      permissions.value.includes('rct_r') &&
      !permissions.value.includes('cadm_r'),
  );

  const hasSpaces = computed(
    () =>
      (isAdmin.value || isRecruiter.value || isManager.value) &&
      !adminOnly.value &&
      !recruiterOnly.value &&
      !managerOneCompany.value,
  );

  function redirectToSpaces() {
    window.location.assign(`${appUrl('auth_url')}/spaces?from=${window.location.href}`);
  }

  return {
    isRecruiter,
    isAdmin,
    isManager,
    hasSpaces,
    redirectToSpaces,
  };
}
